// components
import SvgIconStyle from 'components/SvgIconStyle';
import { TEMPLATE_STATUS } from 'pages/requests/Templates-List';
import { PATH_AUTH, PATH_DASHBOARD } from 'routes/paths';

// ----------------------------------------------------------------------

export const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  home: getIcon('home_icon'),
  requests: getIcon('requests_icon'),
  contentSettings: getIcon('content_settings_icon'),
  logout: getIcon('logout_icon'),
  tags: getIcon('tag_icon'),
  exit: getIcon('exit'),
  webinar: getIcon('webinar'),
  recommendation: getIcon('recommendation'),
};

const sidebarConfig = [
  {
    items: [
      // { title: 'خانه', path: PATH_DASHBOARD.index, icon: ICONS.home },
      {
        title: 'درخواست ها',
        icon: ICONS.requests,
        children: [
          {
            title: 'درخواست های جدید',
            path: `${PATH_DASHBOARD.request.newRequest}?page=1&limit=10`,
          },
          {
            title: 'تمام درخواست ها',
            path: `${PATH_DASHBOARD.request.list}?page=1&limit=10&keyword=&status=${TEMPLATE_STATUS[0].value}`,
          },
          {
            title: 'لیست بروزرسانی ها ',
            path: `${PATH_DASHBOARD.request.edit}?page=1&limit=10&keyword=&status=${TEMPLATE_STATUS[0].value}`,
          },
        ],
      },
      {
        title: 'مدیریت محتوا',
        icon: ICONS.contentSettings,
        children: [
          { title: 'اسلایدر', path: `${PATH_DASHBOARD.slider.list}?page=1&limit=10` },
          { title: 'بنر', path: `${PATH_DASHBOARD.banner.list}?page=1&limit=10` },
          { title: 'ویژگی ها', path: `${PATH_DASHBOARD.feature.list}?page=1&limit=10` },
          { title: 'برچسب ها', path: `${PATH_DASHBOARD.tag.list}?page=1&limit=10`, icon: ICONS.tags },
          { title: 'گالری', path: `${PATH_DASHBOARD.gallery.root}?page=1&limit=10`, icon: ICONS.tags },
        ],
      },
      {
        title: 'وبینار شخصی',
        icon: ICONS.webinar,
        children: [
          {
            title: 'درخواست های جدید',
            path: `${PATH_DASHBOARD.webinar.newRequests}`,
          },
          {
            title: 'تمام درخواست ها',
            path: `${PATH_DASHBOARD.webinar.all}`,
          },
          {
            title: 'در حال اجرا',
            path: `${PATH_DASHBOARD.webinar.onboard}`,
          },
          {
            title: 'کنداکتور',
            path: `${PATH_DASHBOARD.webinar.conductor}`,
          },
        ],
      },
      {
        title: 'پیشنهاد محصول',
        icon: ICONS.recommendation,
        children: [
          {
            title: 'لیست برچسب ها',
            path: `${PATH_DASHBOARD.recommendation.tag.list}`,
          },
          {
            title: 'لیست سوالات',
            path: `${PATH_DASHBOARD.recommendation.question.list}`,
          },
          {
            title: 'مدیریت تضادها',
            path: `${PATH_DASHBOARD.recommendation.conflict.list}`,
          },
          {
            title: 'ارتباطات برچسب',
            path: `${PATH_DASHBOARD.recommendation.relation.list}`,
          },
        ],
      },
      { title: 'خروج', path: PATH_AUTH.logout, icon: ICONS.exit },
    ],
  },
];

export default sidebarConfig;
